export default "__VITE_ASSET__D1Njhg85__"